import React from 'react'
import Patients from '../../Components/Doctor/Patients/Patients'

const DoctorPatientsPage = () => {
  return (
    <div className="p-5"><Patients/></div>
  )
}

export default DoctorPatientsPage